module.exports = __webpack_public_path__ + "img/202409181544354237wy.70a3330a.jpg";